import { useEffect, useState } from 'react';
import { pageHasStickyHeader } from '../utils/pageHasStickyHeader';

export const useStickyHeader = (stickyRef) => {
  const [isSticky, setSticky] = useState(false);
  const { hasSticky, nodeType, pathname, triggerRoute } = pageHasStickyHeader();

  useEffect(() => {
    if (!hasSticky) {
      setSticky(false);
      return;
    }
    if (stickyRef) {
      const cachedRef = stickyRef.current;
      const observer = new IntersectionObserver(([e]) => setSticky(e.intersectionRatio < 1), {
        threshold: [1],
        rootMargin: '40px',
      });

      observer.observe(cachedRef);
      return function () {
        observer.unobserve(cachedRef);
      };
    }
  }, [stickyRef, pathname, nodeType, triggerRoute, hasSticky]);

  return { isSticky };
};
